package com.example.borshi.web.model

/**
 * Represents a customizable protein subscription plan. (JS/WEB version)
 */
data class ProteinPlan(
    val planId: String = "",
    val planName: String = "",
    val description: String = "",
    val price: Double = 0.0,
    val duration: String = "",
    val deliveriesPerWeek: Int = 1,
    val consultationEligible: Boolean = false,
    val imageUrl: String = "",
    val mixItems: List<PlanMixItem> = emptyList(),
    val nutritionistId: String = "",
    val nutritionistName: String = ""
)
